import React, { useState, useEffect, useRef } from 'react';
import { HashLink } from 'react-router-hash-link';
import { ExitToAppOutlined } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  clearAuthToken,
  setContact,
  setEmail,
  setIsContactVerified,
  setIsEmailVerified,
  setUserName,
} from '../../redux/Qps';
import '../../index.css';

const NavLinks = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
 const { token, isEmailVerified, isContactVerified } = useSelector((state) => state.qps);
const isLoggedIn = Boolean(token) && isEmailVerified && isContactVerified;
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(clearAuthToken());
    dispatch(setIsContactVerified(false));
    dispatch(setIsEmailVerified(false));
    dispatch(setContact(''));
    dispatch(setEmail(''));
    dispatch(setUserName(''));
    navigate('/');
  };

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

 const linkClass =
  'inline-block px-4 text-blue-900 font-medium ' +
  'text-sm md:text-base lg:text-lg transition-all duration-300 hover:scale-110 hover:text-[#1E88E5]';
  return (
    <>
      <HashLink smooth to="/#" className={linkClass}>
        Home
      </HashLink>

      <HashLink smooth to="/about" className={linkClass}>
        About Us
      </HashLink>
      <HashLink smooth to="/telecommunications" className={linkClass}>
              Telecommunications
            </HashLink>

      {/* Services Dropdown */}
      <div className="relative inline-block text-left" ref={dropdownRef}>
        <button
          onClick={toggleDropdown}
          className={`flex items-center ${linkClass}`}
        >
          Services
          <svg
            className="ml-2 h-4 w-4 md:h-5 md:w-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>

        {isDropdownOpen && (
          <div className="absolute mt-2 w-72 bg-white shadow-lg rounded-md z-50">
            {[
              { label: 'Accounting', to: '/accounting' },
              { label: 'Application Development', to: '/application-development' },
              { label: 'Consulting', to: '/consulting' },
              { label: 'Digital Marketing', to: '/digital-marketing' },
              { label: 'Staffing & IT Solutions', to: '/staffing' },
              { label: 'Digital Communication', to: '/digitalcommunication' },
            ].map((item) => (
              <HashLink
                key={item.to}
                smooth
                to={item.to}
                onClick={() => setIsDropdownOpen(false)}
                className="
                  block px-4 py-2
                  text-sm md:text-base
                  text-gray-700 hover:text-blue-900
                  hover:bg-gray-100
                "
              >
                {item.label}
              </HashLink>
            ))}
          </div>
        )}
      </div>
    

      {/* <HashLink to="/careers" className={linkClass}>
        Careers
      </HashLink> */}

     {isLoggedIn && (
  <button
          onClick={handleLogout}
          className={`flex items-center gap-2 ${linkClass}`}
        >
          <ExitToAppOutlined fontSize="small" />
          Logout
        </button>
      )}
    </>
  );
};

export default NavLinks;
